import { TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';

interface CommentFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const CommentField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: CommentFieldProps) => {
  return (
    <>
      {/* <TextField
        fullWidth
        label="Comment"
        value={field.dataSource || ""}
        onChange={(e) =>
          handleFieldChange(index, { dataSource: e.target.value })
        }
        multiline
        rows={4}
        placeholder={field.properties?.placeholder || "Enter comment text"}
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter comment text"
      /> */}
    </>
  );
};
